var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIconSellerSocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2283_46990)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2283_46990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6.86851C5 6.41805 5.15766 6.04643 5.47297 5.75364C5.78828 5.46085 6.1982 5.31445 6.7027 5.31445C7.1982 5.31445 7.59909 5.45859 7.90541 5.74689C8.22072 6.04418 8.37838 6.43156 8.37838 6.90905C8.37838 7.34148 8.22523 7.70183 7.91892 7.99013C7.60361 8.28743 7.18919 8.43607 6.67568 8.43607H6.66216C6.16666 8.43607 5.76577 8.28743 5.45946 7.99013C5.15315 7.69283 5 7.31895 5 6.86851ZM5.17568 18.6928V9.6658H8.17568V18.6928H5.17568ZM9.83784 18.6928H12.8378V13.6523C12.8378 13.337 12.8739 13.0937 12.9459 12.9226C13.0721 12.6162 13.2635 12.3572 13.5203 12.1455C13.777 11.9338 14.0991 11.828 14.4865 11.828C15.4955 11.828 16 12.5081 16 13.8685V18.6928H19V13.5172C19 12.1838 18.6847 11.1726 18.0541 10.4834C17.4234 9.79418 16.5901 9.44959 15.5541 9.44959C14.3919 9.44959 13.4865 9.94959 12.8378 10.9496V10.9766H12.8243L12.8378 10.9496V9.6658H9.83784C9.85585 9.95409 9.86486 10.8505 9.86486 12.355C9.86486 13.8595 9.85585 15.9721 9.83784 18.6928Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2283_46990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2283_46990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconSellerSocial);
export default __webpack_public_path__ + "static/media/linkedin-icon-seller-social.46f9eddc7882f423e5521d8a2e72597f.svg";
export { ForwardRef as ReactComponent };